import { WISHLIST_ROUTE_PATH } from "@const/route-paths.const";
import Link from "next/link";
import React from "react";
import BottomMenus from "./BottomMenus";

type Props = {
  handleShowCanvas: () => void;
  isSaleable: boolean;
  isLoading: boolean;
  isWishlist: boolean;
  onUpdateWishList: (isWishlist: boolean) => void;
};

const AddtoCartNavigate = ({
  handleShowCanvas,
  isSaleable,
  isLoading,
  isWishlist,
  onUpdateWishList,
}: Props) => {
  return (
    <>
      <div className="bottom-navigate fixed-bottom bg-white d-block d-lg-none">
        <BottomMenus
          handleShowCanvas={handleShowCanvas}
          isSaleable={isSaleable}
          isLoading={isLoading}
          isWishlist={isWishlist}
          onUpdateWishList={onUpdateWishList}
        />
      </div>
    </>
  );
};

export default AddtoCartNavigate;
